import React, { useEffect, useRef, useState } from "react";
import { Player } from "bitmovin-player";
import { UIFactory } from "bitmovin-player/bitmovinplayer-ui";
import { fetchPlayApiSource } from "@repo/utils";
import "bitmovin-player/bitmovinplayer-ui.css";

// Add the advertising module ONLY when it exists (script loaded) and only once.
function addAdvertisingModuleOnce() {
  if (Player.__adsModuleAdded) return true;

  const adsModule = window?.bitmovin?.player?.["advertising-bitmovin"]?.default;
  if (!adsModule) return false;

  Player.addModule(adsModule);
  Player.__adsModuleAdded = true;
  return true;
}

function BitmovinPlayer() {
  const [player, setPlayer] = useState(null);
  const playerDiv = useRef(null);

  const playerConfig = {
    key: "378a99c6-1097-4afa-a8a8-a70762280eb1",
    analytics: {
      key: "3f192444-fe35-4655-9b7d-ae3a30b0bc52",
    },
    ui: false,
    network: {
      preprocessHttpRequest: (type, request) => {
        if (type === "drm/certificate/fairplay") {
          request.responseType = "arraybuffer";
        }
        return Promise.resolve(request);
      },
    },
    advertising: {
      adBreaks: [
        {
          tag: {
            type: "vmap",
            // More Ad Samples can be found here:
            // https://developers.google.com/interactive-media-ads/docs/sdks/html5/client-side/tags
            url: "https://2a7e9.v.fwmrm.net/ad/g/1?videoProtocol=abr&nw=174055&prof=c4_fire_test&csid=fire.channel4.com%2F4od&caid=75227%2F001&metr=1031&pvrn=42447&vdur=4078&resp=vmap1&vprn=80079&flag=+sltp+vicb+qtcb+slcb&vcid=4f1eb3a9-31f6-4768-b096-9ee64147975d%3B_fw_cookie_consent%3D0&targetedAdvertising=withdrawn&video_session_id=590154686617612901907385480391&barbuid2=mh4ipd6q3m8663w&_fw_vcid2=174055%3A4f1eb3a9-31f6-4768-b096-9ee64147975d%3Bptgt%3Da&tpcl=PREROLL&slid=pre&tpos=0%3Bptgt%3Da&tpcl=MIDROLL&cpsq=1&slid=mid1&tpos=1267.6%3Bptgt%3Da&tpcl=MIDROLL&cpsq=2&slid=mid2&tpos=2137.24%3Bptgt%3Da&tpcl=MIDROLL&cpsq=3&slid=mid3&tpos=2374.04%3Bptgt%3Da&tpcl=MIDROLL&cpsq=4&slid=mid4&tpos=2998.88%3Bptgt%3Da&tpcl=MIDROLL&cpsq=5&slid=mid5&tpos=3327.44%3B&client=amazonfire-dash",
          },
        },
      ],
    },
  };

  useEffect(() => {
    let playerInstance = null;
    let cancelled = false;

    const setupPlayer = async () => {
      // IMPORTANT: do this *after* the ad script is loaded by App.jsx.
      const adsOk = addAdvertisingModuleOnce();
      if (!adsOk) {
        console.warn(
          "Advertising module not available yet. Ensure App waits for the advertising script before rendering BitmovinPlayer.",
        );
        // If you want to hard-fail instead of continuing without ads:
        // throw new Error('Advertising module not loaded')
      }

      const playerSource = await fetchPlayApiSource(
        "https://api-dev.videosolutionhub.com/1.6/A/ENG/DOTCOM/ALL/PLAY/VOD/1110002694",
      );

      if (cancelled) return;

      playerInstance = new Player(playerDiv.current, playerConfig);
      UIFactory.buildDefaultUI(playerInstance);

      await playerInstance.load(playerSource);

      if (cancelled) return;

      setPlayer(playerInstance);
      console.log("Successfully loaded source");
    };

    setupPlayer().catch((err) => {
      if (!cancelled) console.warn(err);
    });

    return () => {
      cancelled = true;
      if (player != null) {
        player.destroy();
        setPlayer(null);
      }
      setPlayer(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id="player" ref={playerDiv} />;
}

export default BitmovinPlayer;
